import {
  Paper,
  Stack,
  Tabs,
  Tab,
  Box,
  Divider,
  Typography,
  useTheme,
  TextField,
  MenuItem,
  InputAdornment,
  IconButton,
  useMediaQuery,
} from "@mui/material";

import React, { useEffect } from "react";
import { useState } from "react";

//icons
import MenuSort from "./menuSort";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";

import VirtualizedAlerts from "./cardAlerts/virtualizacao";
import VirtualizedONU from "./cardONU/vitualizacao";
import VirtualizedCTOS from "./cardCTOs/virtualizacao";
import {
  FilterListOff,
  Home,
  SignalCellularConnectedNoInternet1BarOutlined,
  SignalCellularNodataOutlined,
  SwapVertOutlined,
} from "@mui/icons-material";
import IconTransform from "../iconsElement";
import { transition } from "d3";
import zIndex from "@mui/material/styles/zIndex";

export default function SliderBarMapsRp(props) {
  const {
    iconsElements,
    setFocusNodeId = () => {},
    mapRef,
    elements,
    onusInvalidas = [],
    collapse,
    handleCollapse,
    config,
    configLocal,
  } = props;

  const [alertasTotais, setAlertasTotais] = useState([]);
  const [CTOs, setCTOs] = useState([]);
  const [ONUS, setONUs] = useState([]);
  const [filterHosts, setFilterHosts] = useState("");
  const [filterAlerts, setFilterAlerts] = useState(-1);
  const [filterMaps, setFilterMaps] = useState("");
  const [valueTab, setValueTab] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [sort, setSort] = useState(0);
  const [directionSort, setDirectionSort] = useState(0);
  const [sortOptions, setSortOptions] = useState([
    ["Alertas", "ONU's"],
    [],
    ["Nome", "Potência", "Pendentes"],
  ]);
  const theme = useTheme();

  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (event, newValue) => {
    setValueTab(newValue);
  };

  const styles = {
    textAdorment: {
      ml: "-5px",
      fontSize: "12px",
      fontWeight: 800,
      color: theme.palette.color.bgIcon,
    },
    data: {
      overflow: "auto",
      height: "100%",
      width: "100%",
    },
    menuItem: {
      display: "flex",
      alignItems: "center",
    },
    iconItem: { mr: 1 },
    containerData: {
      overflow: "hidden",
      height: "100%",
    },
    paper: {
      width: collapse ? "0px" : "340px",
      transition: "width 0.3s ease",
      position: "absolute",
      p: collapse ? 0 : 1,
      backgroundColor: theme.palette.background.default,
      borderRight: collapse
        ? "none"
        : "1px solid" + theme.palette.color.appBarBorder,
      height: "calc(100vh - 65px)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      zIndex: 1,
    },
    menuButton: {
      position: "absolute",
      top: 5,
      zIndex: 12000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "50px",
      height: "50px",
    },
    cardNoMaps: {
      background: theme.palette.background.paperSelectedMaps,
      height: "30px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    text: {
      fontSize: "0.875rem",
      color: theme.palette.color.text,
      //textTransform: "none",
    },
    tabs: {
      "& button": {
        color: theme.palette.text.disabled,
        textTransform: "none",
        minHeight: "20px",
        Height: "100%",
        borderRadius: "5px",
        paddingX: "10px",
      },
      "& .MuiTab-icon": { marginRight: "2px" },

      "& button.Mui-selected": {
        backgroundColor: theme.palette.background.tab,
      },
      "& .MuiTabs-indicator": {
        backgroundColor: "transparent",
        border: "none",
      },
    },
    card: {
      borderRadius: "5px",
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 3px  #0000001a",
      border: "none",
      "&::before": {
        display: "none",
      },
    },
    textCount: {
      fontSize: "0.8rem",
      textAlign: "start",
      p: "5px 10px",
      mt: "-5px",
      color: theme.palette.text.disabled,
      backgroundColor: theme.palette.background.paperSelectedMaps,
      mb: "10px",
    },
  };

  useEffect(() => {
    const ftthEscala = config?.escalas?.ftth
      .filter((escala) => escala?.label !== "Sem Dados")
      .map((escala) => parseFloat(escala?.label))
      .filter((n) => Number.isFinite(n))
      .sort((a, b) => a - b);

    const offline = (power) => {
      if (!Number.isFinite(power) || ftthEscala?.length === 0) return true;
      const topo = ftthEscala[ftthEscala.length - 1];

      return power > topo;
    };

    const selectedPowers = new Set(
      (Array.isArray(configLocal?.filtroPotencia)
        ? configLocal.filtroPotencia
        : []
      )
        .map((v) => Number(v))
        .filter(Number.isFinite)
    );

    const ceiling = (p) => {
      if (!Number.isFinite(p) || ftthEscala?.length === 0) return null;
      const idx = ftthEscala.findIndex((c) => c >= p);
      return idx >= 0 ? ftthEscala[idx] : ftthEscala[ftthEscala.length - 1];
    };

    const filteredCTOs = elements.filter((cto) => {
      const rxNum = Number.parseFloat(cto?.data?.potencia?.rx);
      if (!configLocal?.noDataElements && offline(rxNum)) return false;

      if (selectedPowers.size === 0) return true;
      const c = ceiling(rxNum);
      return c !== null && selectedPowers.has(c);
    });
    const onus = [
      ...filteredCTOs?.flatMap((e) => e.elementsClients),
      ...onusInvalidas,
    ];

    const filteredONUs = onus.filter((onu) => {
      const rxNum = Number.parseFloat(onu?.data?.potencia?.rx);
      if (!configLocal?.noDataElements && offline(rxNum)) return false;

      if (selectedPowers.size === 0) return true;
      const c = ceiling(rxNum);
      return c !== null && selectedPowers.has(c);
    });
    setAlertasTotais([
      ...filteredCTOs
        ?.flatMap((ele) => ele?.elementsClients?.flatMap((onu) => onu.alert))
        .filter((a) => a != null),
      ...filteredCTOs?.flatMap((a) => a?.alerts).filter((a) => a != null),
    ]);

    setONUs(filteredONUs);
    setCTOs(filteredCTOs);
  }, [
    elements,
    onusInvalidas,
    config,
    configLocal?.noDataElements,
    configLocal?.filtroPotencia,
  ]);

  const CardNoMaps = () => {
    return (
      <Paper elevation={0} sx={styles.cardNoMaps}>
        <Typography
          sx={styles.text}
          color={theme.palette.mode == "dark" ? "#ffffff6e" : ""}
        >
          Não há equipamentos
        </Typography>
      </Paper>
    );
  };
  const CountList = ({ list }) => {
    return (
      <Typography sx={styles.textCount}>
        {(list.length || 0) + " itens encontrados"}
      </Typography>
    );
  };

  function search(id) {
    setFocusNodeId(id);
    if (mapRef?.current) {
      mapRef.current.focusZoomExt(id);
    }
  }
  const sortCtos = () => {
    if (valueTab != 1) return [];
    let data = CTOs?.filter((cto) =>
      cto?.titulo?.toLowerCase()?.includes(filterMaps.toLowerCase())
    );
    if (sort == 0) {
      return data.sort((a, b) => {
        const alertasA = a.elementsClients.flatMap(
          (client) => client.alert
        )?.length;
        const alertasB = b.elementsClients.flatMap(
          (client) => client.alert
        )?.length;

        return directionSort == 0 ? alertasA - alertasB : alertasB - alertasA; // Ordenação crescente
      });
    } else {
      return data.sort((a, b) => {
        const onusA = a?.elementsClients.length || -41;
        const onusB = b?.elementsClients.length || -41;

        return directionSort == 0 ? onusA - onusB : onusB - onusA; // Ordenação crescente
      });
    }
  };
  const sortONUS = () => {
    if (valueTab != 3) return [];
    let data = ONUS?.filter(
      (onu) =>
        onu?.titulo?.toLowerCase()?.startsWith(filterHosts?.toLowerCase()) ||
        onu?.data?.contrato?.value
          ?.toString()
          ?.toLowerCase()
          ?.startsWith(filterHosts.toLowerCase()) ||
        onu?.data?.usuario?.value
          ?.toLowerCase()
          ?.startsWith(filterHosts.toLowerCase())
    );
    if (sort == 0) {
      return data.sort((a, b) => {
        const tituloA = a.titulo?.toLowerCase();
        const tituloB = b.titulo?.toLowerCase();

        if (tituloA < tituloB) return directionSort == 0 ? -1 : 1;
        if (tituloA > tituloB) return directionSort == 0 ? 1 : -1;
        return 0;
      });
    } else if (sort == 1) {
      return data.sort((a, b) => {
        const potenciaA = a.data.potencia.rx || -41;
        const potenciaB = b.data.potencia.rx || -41;

        return directionSort == 0
          ? potenciaA - potenciaB
          : potenciaB - potenciaA; // Ordenação crescente
      });
    } else {
      return data.sort((a, b) => {
        const getPriority = (item) => {
          if (item.isValid && item.hasCto) return 0;
          if (!item.isValid && item.hasCto) return 1;
          if (item.isValid && !item.hasCto) return 2;
          return 3;
        };
        const aPriority = getPriority(a);
        const bPriority = getPriority(b);

        return directionSort == 0
          ? aPriority - bPriority
          : bPriority - aPriority;
      });
    }
  };

  return (
    <>
      <Box sx={styles.menuButton}>
        <IconButton
          onClick={handleCollapse}
          sx={{
            p: 0.5,
          }}
        >
          <MenuIcon />
        </IconButton>
      </Box>
      <Stack sx={styles.paper}>
        {!collapse && (
          <Stack direction="column" gap={2} height="calc(100vh - 65px)">
            <Stack sx={[styles.card, { p: 0.5, mt: 2, height: "50px" }]}>
              <Tabs
                variant="fullWidth"
                value={valueTab}
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                sx={styles.tabs}
              >
                <Tab
                  icon={
                    valueTab == 1 ? (
                      <Box sx={{ height: "24px" }}>
                        <IconTransform
                          img={
                            iconsElements?.find((icon) => icon.nome == "_cto")
                              ?.img
                          }
                          color={valueTab == 1 && theme.palette.primary.main}
                          size="24px"
                        />
                      </Box>
                    ) : null
                  }
                  label="CTOs"
                  value={1}
                  sx={styles.text}
                  iconPosition={"start"}
                />
                <Tab
                  sx={styles.text}
                  icon={valueTab == 2 ? <BoltOutlinedIcon /> : null}
                  label="Alertas"
                  value={2}
                  iconPosition={"start"}
                />
                <Tab
                  sx={styles.text}
                  icon={valueTab == 3 ? <Home /> : null}
                  label="ONUs"
                  value={3}
                  iconPosition={"start"}
                />
              </Tabs>
            </Stack>

            <Stack gap={2} sx={styles.containerData}>
              {valueTab == 1 && (
                <>
                  <Stack direction={"row"} gap={0.5} alignItems={"center"}>
                    <TextField
                      id="outlined-basic"
                      placeholder="Buscar"
                      autoComplete="off"
                      variant="outlined"
                      size="small"
                      value={filterMaps}
                      onChange={(event) => setFilterMaps(event.target.value)}
                      sx={{ width: "100%" }}
                      slotProps={{
                        input: {
                          endAdornment: (
                            <SearchIcon
                              sx={{ color: theme.palette.color.iconsDisable }}
                            />
                          ),
                        },
                      }}
                    />
                    <IconButton
                      size="small"
                      sx={{ width: "40px", height: "40px" }}
                      onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                      <SwapVertOutlined />
                    </IconButton>
                  </Stack>

                  <VirtualizedCTOS
                    lista={sortCtos()}
                    style={styles.data}
                    search={search}
                    iconsElements={iconsElements}
                  />
                  <CountList list={sortCtos()} />
                </>
              )}

              {valueTab == 2 && (
                <>
                  <TextField
                    select
                    size="small"
                    value={filterAlerts}
                    onChange={(event) => setFilterAlerts(event.target.value)}
                    placeholder="Severidade"
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography sx={styles.textAdorment}>
                              ALERT
                            </Typography>
                          </InputAdornment>
                        ),
                      },
                      select: {
                        MenuProps: {
                          sx: { zIndex: 10000 },
                        },
                      },
                    }}
                  >
                    <MenuItem value={-1}>
                      <FilterListOff sx={{ mr: 1 }} />
                      Todos
                    </MenuItem>
                    <Divider />
                    <MenuItem value={0}>
                      <SignalCellularNodataOutlined sx={{ mr: 1 }} />
                      Offline
                    </MenuItem>
                    <MenuItem value={1}>
                      <SignalCellularConnectedNoInternet1BarOutlined
                        sx={{ mr: 1 }}
                      />
                      Baixa Potência
                    </MenuItem>
                  </TextField>
                  <VirtualizedAlerts
                    alertasTotais={alertasTotais.filter(
                      (a) => a.severity == filterAlerts || filterAlerts == -1
                    )}
                    style={styles.data}
                    search={search}
                  />
                  <CountList
                    list={alertasTotais.filter(
                      (a) => a.severity == filterAlerts || filterAlerts == -1
                    )}
                  />
                </>
              )}

              {valueTab == 3 && (
                <>
                  <Stack direction={"row"} gap={0.5} alignItems={"center"}>
                    <TextField
                      id="outlined-basic"
                      placeholder="Buscar"
                      autoComplete="off"
                      variant="outlined"
                      size="small"
                      value={filterHosts}
                      onChange={(event) => setFilterHosts(event.target.value)}
                      sx={{ width: "100%" }}
                      slotProps={{
                        input: {
                          endAdornment: (
                            <SearchIcon
                              sx={{ color: theme.palette.color.iconsDisable }}
                            />
                          ),
                        },
                      }}
                    />
                    <IconButton
                      size="small"
                      sx={{ width: "40px", height: "40px" }}
                      onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                      <SwapVertOutlined />
                    </IconButton>
                  </Stack>

                  <VirtualizedONU
                    lista={sortONUS()}
                    style={styles.data}
                    search={search}
                    iconsElements={iconsElements}
                  />

                  <CountList list={sortONUS()} />
                </>
              )}
            </Stack>
          </Stack>
        )}
      </Stack>
      <MenuSort
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        options={sortOptions[valueTab - 1]}
        direction={directionSort}
        setDirection={setDirectionSort}
        sort={sort}
        setSort={setSort}
      />
    </>
  );
}
